import { url, UpImgUri, UpFileUri } from './url';
import { get, fetch } from './axios'

let customer = {
    /*不同模块不同前缀*********************************************************************************************/
    constantString() { //上传图片地址
        return UpImgUri;
    },
    UpFileUriString() { //上传文件地址
        return UpFileUri;
    },
    baseReportUrl() {
        return url + '/reporting'; //报表模块
    },
    baseCustomerQueryUrl() {
        return url + '/customerQuery';
    },
    baseResourceUrl() {
        return url + '/resource'; //资源模块
    },
    baseCustomerUrl() {
        return url + '/customer'; //客户模块前缀
    },
    basesalesUrl () {
        return url + '/sales';//销售模块前缀
    },
    url(){
        return url;
    },
    /*不同模块不同前缀*********************************************************************************************/
    /*********第三方报表与文件上传的配置冲突，所以需要改文件上传的路径，在所有的文件上传接口前增加/zuul前缀********/
    baseCustomerUploadUrl(){//客户上传
        return url+'/zuul/customer'
    },
    baseSalesUploadUrl(){//销售上传
        return url+'/zuul/sales'
    },
    baseResourceUploadUrl(){
        return url + '/zuul/resource'; //资源上传
    },
    basePartyUploadUrl() {
        return url + '/zuul/smartparty';
    },
    /**
     * 用户登录
     */
    login(params) {
        return fetch(url + "/oauthep/uaa/oauth/token", params);
        // return fetch('http://139.159.250.246:9981' + "/oauthep/uaa/oauth/token", params);
        // return fetch(url + "/oauthep/uaa/oauth/token", params);
    },
    loginOut(params) { //退出登录，回收token
        return deletes(url + "/oauthep/uaa/tokens/revoke", params);
    },

    /*****************************菜单管理****************************************/
    /*菜单管理开始*/
    getMenuTypeList(params) { //获取菜单类型 //常量
        return get(basicUrl + '/system_constants/show', params)
    },
}
export default customer;